export default __webpack_public_path__ + "static/media/logoColor.2030dfe1.svg";